import { sumBy } from "lodash"
import type { IVariantSummary } from "~/hooks/useVariantTableData"
import { resolveVariantBuyQuantities } from "~/utils/noosBuyFill"

// Summed per SKU across warehouses. Keeps both MOQ figures (`moqQuantity` only with respectMoq)
// so the fold-out resolves one figure source for the whole variant.
export type SkuSuggestedOrder = {
  quantity: number
  moqQuantity: number
}
export type SkuSuggestedOrderMap = Map<string, SkuSuggestedOrder>

/** Sum of a variant's SKU-level suggested order quantities. */
export function computeVariantSuggestedQty(
  variant: IVariantSummary,
  skuSuggestedOrderData: SkuSuggestedOrderMap,
): number {
  return variant.skuIds.reduce(
    (sum, skuId) => sum + (skuSuggestedOrderData.get(skuId)?.quantity ?? 0),
    0,
  )
}

// MOQ rounding is not additive, so aggregated rows must sum each variant's own figure rather than
// re-round the pooled SKUs.
export function computeVariantMoqQty(
  variant: IVariantSummary,
  skuSuggestedOrderData: SkuSuggestedOrderMap,
): number {
  const lines = variant.skuIds.map((skuId) => ({
    skuId,
    quantity: skuSuggestedOrderData.get(skuId)?.quantity ?? 0,
    moqQuantity: skuSuggestedOrderData.get(skuId)?.moqQuantity ?? 0,
  }))
  return sumBy(
    resolveVariantBuyQuantities(lines, () => variant.variantId),
    "quantity",
  )
}
